/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { Usuario } from '../models/usuario';

/**
 * API responsavel pelos dados do usuário
 */
@Injectable({
  providedIn: 'root',
})
class UsuarioService extends __BaseService {
  static readonly recuperarDadosUsuarioPath = '/usuario/recuperar-dados';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Recupera dados do usuário
   * @return Operacao realizada com sucesso
   */
  recuperarDadosUsuarioResponse(): __Observable<__StrictHttpResponse<Usuario>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/usuario/recuperar-dados`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Usuario>;
      })
    );
  }
  /**
   * Recupera dados do usuário
   * @return Operacao realizada com sucesso
   */
  recuperarDadosUsuario(): __Observable<Usuario> {
    return this.recuperarDadosUsuarioResponse().pipe(
      __map(_r => _r.body as Usuario)
    );
  }
}

module UsuarioService {
}

export { UsuarioService }
